import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { MessageService } from 'primeng/api';

import type { PauImportPageComponent } from '../pages/user-pages/pau-import-page/pau-import-page.component';
import { UnsavedChangesService } from '../services/unsaved-changes.service';

/**
 * Уход со страницы импорта из ПАУ (Q-3 СА CRM-108): пока идёт создание — нельзя (сервер всё равно создаст должника,
 * а пользователь не увидит результата), иначе — обычный вопрос Д-13.
 */
export const pauImportLeaveGuard: CanDeactivateFn<PauImportPageComponent> = (page) => {
  if (page.creating$$()) {
    inject(MessageService).add({ severity: 'warn', summary: 'Должник создаётся, дождитесь окончания' });
    return false;
  }
  return inject(UnsavedChangesService).confirmLeave();
};
